export default "__VITE_ASSET__DkvP3w6D__"